/**
 * Authenticator apps ask for the base32 secret in four-character groups, which
 * is also how the setup screen prints it.
 */
export const formatSetupKey = (secret: string): string =>
  secret.match(/.{1,4}/g)?.join(' ') ?? secret;
